import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;

  const logo = (
    <Box sx={{ width: 40, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1280.000000 1280.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,1280.000000) scale(0.100000,-0.100000)"
        >
          <path
            d="M1335 7034 c-155 -22 -261 -87 -321 -197 -24 -45 -28 -62 -27 -132 0
-95 17 -138 75 -201 59 -64 129 -97 335 -159 270 -82 321 -121 311 -242 -7
-87 -55 -133 -167 -159 -197 -47 -367 32 -418 193 -17 53 -18 54 -49 48 -18
-3 -56 -12 -84 -21 -50 -15 -51 -16 -45 -47 12 -62 66 -156 120 -210 101 -102
223 -143 405 -134 129 6 188 22 267 74 61 40 99 87 130 162 39 95 28 190 -33
287 -60 97 -148 145 -374 209 -239 67 -300 107 -300 198 0 105 90 167 243 167
67 0 92 -5 137 -26 59 -27 129 -94 151 -143 8 -17 21 -31 29 -31 15 0 119 25
148 35 23 8 -46 124 -113 192 -64 64 -132 102 -215 122 -55 12 -165 21 -205
15z"
          />
          <path
            d="M7665 7020 c-161 -21 -279 -112 -320 -245 -19 -65 -19 -110 2 -170
19 -57 23 -63 80 -121 65 -66 119 -89 438 -183 133 -39 198 -100 198 -186 0
-92 -58 -152 -173 -179 -83 -20 -131 -20 -205 -1 -106 28 -175 92 -213 197
-17 48 -18 49 -52 43 -54 -9 -130 -36 -130 -45 0 -17 45 -127 66 -160 31 -51
115 -127 171 -154 81 -41 131 -50 263 -50 157 -1 241 24 327 93 82 66 123 150
123 250 0 61 -5 84 -30 135 -64 136 -136 177 -480 277 -187 54 -243 112 -210
216 26 82 107 127 230 127 142 0 205 -39 304 -188 13 -18 15 -18 87 -1 41 10
77 21 81 24 14 13 -54 130 -106 182 -87 87 -159 122 -286 139 -84 11 -82 11
-165 0z"
          />
          <path d="M2100 6390 l0 -621 83 3 82 3 0 615 0 615 -82 3 -83 3 0 -621z" />
          <path
            d="M2470 6390 l0 -621 78 3 77 3 2 410 c1 226 5 412 9 415 9 7 13 0 95
-180 39 -85 79 -173 89 -195 20 -43 134 -290 181 -393 29 -62 30 -63 65 -60
40 3 42 6 102 138 22 47 49 108 62 135 42 91 135 294 183 395 19 41 44 97 56
123 12 26 26 45 31 42 6 -4 10 -167 10 -421 l0 -414 75 0 75 0 0 620 0 620
-73 0 -73 0 -21 -42 c-12 -24 -76 -160 -143 -303 -67 -143 -143 -305 -169
-360 -27 -55 -60 -128 -76 -162 -15 -35 -32 -63 -37 -63 -7 0 -101 187 -168
335 -5 11 -43 91 -84 178 -42 87 -76 160 -76 162 0 2 -27 60 -60 129 l-60 126
-75 0 -75 0 0 -620z"
          />
          <path
            d="M3870 6390 l0 -621 83 3 82 3 2 210 c1 116 3 215 3 222 0 8 62 12
218 15 215 3 217 3 274 32 75 37 146 108 182 182 24 48 30 76 34 147 6 115
-14 193 -70 267 -54 73 -110 114 -192 139 -62 19 -92 21 -342 21 l-274 0 0
-620z m605 428 c68 -37 105 -111 105 -209 0 -109 -60 -189 -165 -219 -25 -7
-104 -10 -208 -8 l-168 3 1 224 c0 123 2 227 4 230 2 3 93 4 203 1 159 -4 204
-8 228 -22z"
          />
          <path
            d="M4960 6390 l0 -620 360 0 361 0 -3 83 -3 82 -265 2 c-146 2 -270 3
-277 3 -8 0 -11 135 -12 533 l0 532 -81 3 -80 3 0 -621z"
          />
          <path
            d="M5880 6390 l0 -620 383 0 c211 0 386 2 388 4 2 2 3 41 1 86 l-4 81
-296 -1 -297 -2 0 189 0 188 247 3 247 2 3 85 3 85 -250 2 -250 3 0 170 0 170
300 5 c165 3 300 7 300 8 0 1 -1 37 -2 79 l-2 78 -385 3 -386 2 0 -620z"
          />
          <path
            d="M8460 6593 c0 -450 2 -469 55 -576 30 -62 120 -154 180 -184 118 -60
294 -74 409 -34 220 78 326 246 326 521 0 49 -3 95 -6 104 -5 13 -23 16 -89
16 l-83 0 -1 -122 c-2 -179 -17 -224 -99 -300 -72 -66 -143 -88 -252 -77 -110
12 -186 63 -238 162 l-27 52 -3 428 -3 427 -84 0 -85 0 0 -417z"
          />
          <path
            d="M8880 6926 l0 -83 51 -7 c60 -8 141 -45 191 -86 55 -46 108 -140 121
-215 l11 -65 84 0 85 0 -6 63 c-16 168 -134 337 -292 417 -68 34 -159 60 -210
60 l-35 0 0 -84z"
          />
          <path
            d="M9628 7000 c-1 -5 -2 -285 0 -621 l2 -611 308 4 c283 4 311 6 360 25
70 28 118 66 153 121 109 171 62 408 -97 490 l-35 18 36 32 c19 18 47 52 63
75 25 39 27 49 27 147 0 91 -4 111 -24 150 -31 59 -95 120 -156 151 -49 24
-56 24 -342 27 -195 2 -292 -1 -295 -8z m530 -156 c117 -24 161 -197 73 -286
-51 -50 -93 -59 -273 -56 l-153 3 -3 173 -2 172 164 0 c90 0 177 -3 194 -6z
m67 -523 c80 -36 122 -114 112 -209 -7 -67 -43 -117 -107 -149 -41 -22 -57
-23 -237 -23 l-193 0 0 200 0 200 193 0 c165 0 198 -3 232 -19z"
          />
          <path
            d="M10642 6393 l3 -618 300 0 c273 0 305 2 360 20 83 28 164 107 195
190 32 87 32 202 1 275 -27 62 -89 133 -133 151 -15 6 -28 13 -28 14 0 2 19
23 42 47 72 75 99 169 78 274 -22 112 -100 204 -204 243 -53 20 -75 21 -336
21 l-280 0 2 -617z m568 435 c58 -30 83 -74 83 -147 0 -97 -43 -151 -136 -171
-30 -6 -114 -10 -197 -8 l-145 3 -3 160 c-1 87 0 165 2 172 4 10 46 13 179 13
159 0 176 -2 217 -22z m21 -503 c88 -31 123 -87 123 -193 -1 -65 -4 -76 -30
-110 -17 -20 -50 -47 -75 -60 -42 -21 -53 -22 -239 -20 l-195 3 -3 198 -2 197
189 0 c144 0 199 -4 232 -15z"
          />
          <path
            d="M8880 6696 c0 -43 2 -46 25 -46 69 0 137 -59 157 -136 12 -42 14 -44
50 -44 35 0 38 2 38 28 0 34 -40 117 -75 154 -36 38 -103 75 -152 83 l-43 7 0
-46z"
          />
          <path
            d="M8880 6515 l0 -45 45 0 c39 0 45 3 45 20 0 25 -46 70 -71 70 -16 0
-19 -8 -19 -45z"
          />
        </g>
      </svg>
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>;
}
